import {CompetitorDomainModel} from "../../../domain/common/competitor/models/competitor-domain-model";
import {ScoreboardWidgetCompetitorViewModel} from "./scoreboard-widget.competitor-view-model";

export class ScoreboardWidgetTennisCompetitorViewModel extends ScoreboardWidgetCompetitorViewModel {
  domainModel: CompetitorDomainModel;

  get name(): String {
    const name: String = this.domainModel.shortName || this.domainModel.name;
    const tennisName: String = `${name} (${this.domainModel.country.name})`;

    return tennisName;
  }
}
